(function(){
    angular
        .module('app')
        .directive('setFocus', setFocus);

        setFocus.$inject = ['$timeout'];
        function setFocus($timeout){
            return {
            //require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
            	element.bind('click',function(){
	               document.querySelector('#' + $attrs.setFocus).focus();
	            })
            }
          }
      }
})();